<template>
  <transition name="fade">
    <div v-if="showDialog" class="dialog-container">
      <div class="dialog" :class="inDetail && 'in-detail'">
        <div v-if="title" class="dialog-header">{{ title }}</div>
        <div class="dialog-content">
          <template v-if="isHtmlDisplay" >
            <div v-html="content" />
          </template>
          <template v-else>
            {{ content }}
          </template>
        </div>
        <div class="dialog-footer">
          <button type="button" v-if="positiveButtonLabel" @click="tapPositive">
            {{ positiveButtonLabel }}
          </button>
          <button type="button" v-if="negativeButtonLabel" @click="tapNegative">
            {{ negativeButtonLabel }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CouponWithCartDialog',
  props: {
    positiveButtonLabel: { type: String, default: '' },
    negativeButtonLabel: { type: String, default: '' },
    inDetail: { type: Boolean, default: false }
  },
  data() {
    return {
      showDialog: false,
      title: '',
      content: '',
      isHtmlDisplay: false
    }
  },
  methods: {
    show({ title = '', content, isHtmlDisplay = false }) {
      this.title = title
      this.content = content
      this.isHtmlDisplay = isHtmlDisplay
      this.showDialog = true
    },
    close() {
      this.showDialog = false
    },
    tapPositive() {
      this.$emit('positive')
    },
    tapNegative() {
      this.$emit('negative')
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;

  .dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: space-around;
    border-radius: 12px;
    background: #ffffff;
    width: 75%;
    max-height: 50%;
    color: #333333;
    overflow: hidden;

    &.in-detail {
      width: 80%;
      max-height: 80%;
    }

    .dialog-header {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-weight: bold;
      flex-shrink: 0;
      font-size: 16px;
      padding: 24px 12px;
    }

    .dialog-content {
      width: 100%;
      font-size: 13px;
      text-align: left;
      padding: 0 24px 24px;
      overflow: scroll;
    }

    .dialog-footer {
      position: relative;
      display: flex;
      width: 100%;
      background: #cccccc;
      padding-top: 1px;
      flex-shrink: 0;

      & > * + * {
        margin-left: 1px;
      }

      button {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: auto;
        height: 43px;
        background: #ffffff;
        font-size: 16px;
        color: #66160E;
      }
    }
  }
}
</style>
